import {useEffect} from 'react'

import {useNavigation} from '@/utils/hooks/useNavigation'
import {ROUTE_TO_PAGENAME} from '@/utils/pageNames'
import {analytics} from '@/utils/tracking/analytics'

export const usePageTracking = () => {
  const router = useNavigation()
  const route = router.route
  const pathname = router.pathname
  const pageName = ROUTE_TO_PAGENAME[route] || route

  // Keyed on the real path rather than `pageName`: `route` is the placeholder form, so every
  // `/class-assist/trademark-class/[id]` shares a single name and a client-side 34 -> 35
  // navigation would never re-run this effect. `pageName` is derived from the path, so listing
  // it too is redundant - the effect still fires exactly once per navigation.
  useEffect(() => {
    analytics.page(pageName)
  }, [pathname, pageName])
}
